{
  "planGen": {
    "preparingContext": "正在准备计划生成上下文……",
    "generatingStructure": "正在生成计划结构……",
    "refiningExecSummary": "正在优化计划结构（执行摘要分类）……",
    "enrichmentComplete": "丰富完成——正在组装计划……",
    "reviewingAlignment": "正在核查计划一致性……",
    "applyingTemplate": "正在应用模板格式……",
    "savingTemplate": "正在保存模板……",
    "finalizing": "正在完成计划结构……",
    "foundSections": "已发现 {{count}} 个章节",
    "enrichingDetails": "正在丰富章节详情（{{done}}/{{total}} 次调用已完成）",
    "enrichingStart": "正在丰富 {{count}} 个章节，共 {{agents}} 个并行调用……",
    "rateLimited": "速率受限——{{seconds}}秒后重试（第 {{attempt}}/{{max}} 次）……",
    "enrichBatchFailed": "第 {{batch}}/{{total}} 批丰富处理失败——继续处理。",
    "complete": "计划生成完成",
    "connectionInterrupted": "连接中断——正在检查进度……",
    "readingInputs": "正在读取任务说明和输出模板……",
    "extractingConstraints": "正在提取需求与约束……",
    "retrievingKnowledge": "正在检索方法论与领域知识……",
    "discoveringTools": "正在识别可用的分析工具……",
    "elapsedOfBudget": "已用 {{elapsed}} 秒，预算 {{budget}} 秒"
  },
  "contentGen": {
    "preparingContext": "正在准备上下文：{{title}}",
    "generatingContent": "正在生成内容：{{title}}",
    "contentWrittenVerbatim": "章节「{{title}}」内容已按原文写入",
    "contentGenerated": "章节「{{title}}」内容已生成"
  },
  "sectionRegen": {
    "starting": "正在开始重新生成……",
    "refiringExecSummary": "正在重新执行执行摘要……",
    "retrievingContext": "正在检索上下文……",
    "contextReady": "上下文已就绪",
    "generating": "正在生成内容……",
    "finalizing": "正在完成……"
  },
  "sectionGen": {
    "allGenerated": "所有章节已生成。正在启动整体跨章节一致性检查。",
    "holisticWaiting": "整体自检正在等待 {{count}} 个失败章节。请重试以继续。",
    "normalizingInconsistencies": "正在修正 {{count}} 个跨章节不一致项。",
    "holisticComplete": "整体自检完成。章节已准备好供审阅。",
    "generatingExecSummary": "正在根据已自检的报告内容生成执行摘要。"
  }
}
